"use strict";
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        /**
         * The Numbers helper namespace.
         */
        var Numbers;
        (function (Numbers) {
            /**
             * Used by $dyn.util.Numbers.DynNumber when parsing a number
             * @internal
             */
            var SignInfo = /** @class */ (function () {
                function SignInfo() {
                    this.negative = false;
                    this.value = "";
                }
                return SignInfo;
            }());
            Numbers.SignInfo = SignInfo;
            /**
             * Used by $dyn.util.Numbers.DynNumber when adding digits
             * @internal
             */
            var AddResult = /** @class */ (function () {
                function AddResult() {
                    this.value = "";
                    this.carry = "";
                }
                return AddResult;
            }());
            Numbers.AddResult = AddResult;
            /**
             * Used by $dyn.util.Numbers.DynNumber to represent a parsed number
             * @internal
             */
            var InternalNumber = /** @class */ (function () {
                /**
                 * Constructor for InternalNumber class
                 * @param integerValue The initial integer value
                 */
                function InternalNumber(integerValue) {
                    this.integer = "";
                    this.decimal = "";
                    this.negative = false;
                    this.isZero = false;
                    this.isNaN = false;
                    this.isBlank = false;
                    this.showPositive = false;
                    this.signMultiplier = 1;
                    if (integerValue) {
                        this.integer = integerValue;
                    }
                }
                return InternalNumber;
            }());
            Numbers.InternalNumber = InternalNumber;
            /**
             * Used by $dyn.controls.Number to represent their _parsedValue
             */
            var DynNumber = /** @class */ (function () {
                /**
                 * Constructor for DynNumber class
                 * @param ignoreDecimal Whether or not to ignore the decimal portion
                 * @param numberFormat The number format used
                 */
                function DynNumber(ignoreDecimal, numberFormat) {
                    // true if this number should be treated as an integer
                    this._ignoreDecimal = ignoreDecimal;
                    // use the default number format from Globalize if one is not specified
                    this._numberFormat = numberFormat === undefined ? Globalize.culture().numberFormat : numberFormat;
                    this.numberStructInternal = new InternalNumber();
                }
                /**
                 * Sets the internal number format
                 * @param numberFormat The number format to be used
                 */
                DynNumber.prototype.SetNumberFormat = function (numberFormat) {
                    this._numberFormat = numberFormat;
                };
                DynNumber.prototype.GetNumberFormat = function () {
                    return this._numberFormat;
                };
                /**
                 * Parses a value string and stores the result on the internal number struct
                 * @param value The value to set on the DynNumber
                 */
                DynNumber.prototype.SetValue = function (value) {
                    this.numberStructInternal = this._parseNumber(value + "", this._numberFormat);
                };
                /**
                 * Gets the formatted value
                 * @returns The formatted value
                 */
                DynNumber.prototype.GetValue = function () {
                    return this.formatNumber(this.numberStructInternal, this._numberFormat);
                };
                /**
                 * Gets the value as a number
                 * @returns The value
                 */
                DynNumber.prototype.GetNumber = function () {
                    if (this.IsNaN()) {
                        return NaN;
                    }
                    else {
                        return Number(this.GetNumberString());
                    }
                };
                /**
                 * Returns the fixed string representation of the number in the wire format
                 * @returns The string representation of the value.
                 */
                DynNumber.prototype.GetNumberString = function () {
                    var numStr = "";
                    if (!this.IsNaN()) {
                        if (this.numberStructInternal.negative) {
                            numStr += "-";
                        }
                        var _fixDecimalResult = {};
                        if (!this._ignoreDecimal) {
                            _fixDecimalResult = this._fixDecimal(this.numberStructInternal.decimal, this._numberFormat);
                        }
                        if (_fixDecimalResult.roundUp) {
                            numStr += this._addPositiveIntegers(this.numberStructInternal.integer, "1");
                        }
                        else {
                            numStr += this.numberStructInternal.integer;
                        }
                        if (!this._ignoreDecimal) {
                            numStr += _fixDecimalResult.decimalString;
                        }
                    }
                    return numStr;
                };
                /**
                 * Gets whether or not the current value is NaN
                 * @returns Return true if current value is NaN, otherwise false
                 */
                DynNumber.prototype.IsNaN = function () {
                    return this.numberStructInternal.isNaN;
                };
                /**
                 * Gets whether or not the current value is negative
                 * @returns Return true if current value is negative, otherwise false
                 */
                DynNumber.prototype.IsNegative = function () {
                    return this.numberStructInternal.negative;
                };
                /**
                 * Gets whether or not the current value is zero
                 * @returns Return true if current value is zero, otherwise false
                 */
                DynNumber.prototype.IsZero = function () {
                    return this.numberStructInternal.isZero;
                };
                /**
                 * Gets whether or not the current value is a blank string
                 * @returns Return true if current value is blank, otherwise false
                 */
                DynNumber.prototype.IsBlank = function () {
                    return this.numberStructInternal.isBlank;
                };
                /**
                 * Sets the sign multiplier on the internal number struct
                 * @param value The number to multiply the number by to possibly toggle the sign
                 */
                DynNumber.prototype.SignMultiplier = function (value) {
                    // Specify -1 to toggle the sign of the displayed value
                    this.numberStructInternal.signMultiplier = value;
                };
                /**
                 * Sets the show positive flag on the internal number struct
                 * @param value Whether or not to show the positive sign on the formatted value
                 */
                DynNumber.prototype.ShowPositive = function (value) {
                    this.numberStructInternal.showPositive = value;
                };
                /**
                 * Comapares itself to the specified number string
                 * @param numberStr The number string to compare to itself
                 * @returns if this > numberStr: 1, if this < numberStr: -1 , if this == numberStr: 0, if either isNaN: -1
                 */
                DynNumber.prototype.CompareToStr = function (numberStr) {
                    var compare = -1;
                    if (numberStr || numberStr === "") {
                        // Make sure it is a string
                        numberStr = numberStr.toString();
                        var otherNumber = this._parseNumber(numberStr, this._numberFormat);
                        compare = this._compareNumbers(this.numberStructInternal, otherNumber, this._ignoreDecimal);
                    }
                    return compare;
                };
                /**
                 * Compares itself to the specified $dyn.util.Numbers.DynNumber
                 * @param  dynValue The DynNumber to compare to itself
                 * @returns if this > numberStr: 1, if this < numberStr: -1 , if this == numberStr: 0, if either isNaN: -1
                 */
                DynNumber.prototype.CompareToDynNumber = function (dynValue) {
                    return this._compareNumbers(this.numberStructInternal, dynValue.numberStructInternal, this._ignoreDecimal);
                };
                /**
                 * Determines if the specified numberStr starts with the specified pattern
                 * @param numberStr The number string to be searched on
                 * @param pattern The pattern to try to match
                 * @returns True if numberStr begins with pattern, otherwise false
                 */
                DynNumber.prototype._startsWith = function (numberStr, pattern) {
                    return numberStr.indexOf(pattern) === 0;
                };
                /**
                 * Determines if the specified numberStr ends with the specified pattern
                 * @param numberStr The number string to be searched on
                 * @param pattern The pattern to try to match
                 * @returns True if numberStr ends with pattern, otherwise false
                 */
                DynNumber.prototype._endsWith = function (numberStr, pattern) {
                    return numberStr.substr(numberStr.length - pattern.length) === pattern;
                };
                /**
                 * Pad the number string with zeros
                 * @param numberStr The number string that will be padded
                 * @param count The nubmer of zeros to add
                 * @param padLeft If true pad to the left, otherwise pad to the right
                 * @returns The padded number string
                 */
                DynNumber.prototype._padZeros = function (numberStr, count, padLeft) {
                    var len;
                    if (padLeft) {
                        for (len = numberStr.length; len < count; len++) {
                            numberStr = "0" + numberStr;
                        }
                    }
                    else {
                        for (len = numberStr.length; len < count; len++) {
                            numberStr += "0";
                        }
                    }
                    return numberStr;
                };
                /**
                 * Trims any leading zeros from number string
                 * @param numberStr The number string that will be trimmed
                 * @returns The trimmed number string
                 */
                DynNumber.prototype._trimLeadingZeros = function (numberStr) {
                    var trimmedValue = numberStr;
                    var match = this.nonZeroDigit.exec(numberStr);
                    if (match) {
                        if (match.index) {
                            trimmedValue = numberStr.substr(match.index);
                            if (trimmedValue.length === 0) {
                                trimmedValue = "0";
                            }
                        }
                    }
                    else {
                        trimmedValue = "0";
                    }
                    return trimmedValue;
                };
                /**
                 * Parses number string and returns object with the value and sign
                 * @param numberStr The number string that will be parsed
                 * @param format The number format used for parsing
                 * @returns The object containing the value and sign
                 */
                DynNumber.prototype._parseSignAndValue = function (numberStr, format) {
                    var negativeSign = format["-"];
                    var positiveSign = format["+"] || "+";
                    var groupSep = format[","];
                    // Trim the input
                    var digits = numberStr.trim();
                    // If we are not using the wire format and there is no group separator, use the culture default
                    if (!format.IsWire && (!groupSep || (groupSep.length === 0))) {
                        groupSep = Globalize.culture().numberFormat[","];
                    }
                    // Split the value on the separator character and rejoin without one
                    if (digits.indexOf(groupSep) > -1) {
                        digits = digits.split(groupSep).join("");
                    }
                    var ret = new SignInfo();
                    ret.negative = false;
                    ret.value = digits;
                    // Test for negative patterns starting with the most common
                    if (this._startsWith(digits, negativeSign)) {
                        // -n | - n
                        ret.negative = true;
                        ret.value = digits.substr(negativeSign.length);
                    }
                    else if (this._endsWith(digits, negativeSign)) {
                        // n- | n -
                        ret.negative = true;
                        ret.value = digits.substr(0, digits.length - negativeSign.length);
                    }
                    else {
                        var startsWith = this._startsWith(digits, "(");
                        var endsWith = this._endsWith(digits, ")");
                        if ((startsWith) || (endsWith)) {
                            // (n)
                            ret.negative = true;
                            if (startsWith && endsWith) {
                                ret.value = digits.substr(1, digits.length - 2);
                            }
                            else {
                                // (n or n) but not both
                                ret.value = Number.NaN.toString();
                            }
                        }
                        else if (this._startsWith(digits, positiveSign)) {
                            // +n | + n
                            ret.value = digits.substr(positiveSign.length);
                        }
                        else if (this._endsWith(digits, positiveSign)) {
                            // n+ | n +
                            ret.value = digits.substr(0, digits.length - positiveSign.length);
                        }
                    }
                    ret.value = ret.value.trim();
                    return ret;
                };
                /**
                 * Takes two equal length strings and a carry value and adds them.
                 * @param left First number to add
                 * @param right Second number to add
                 * @param carry The carry value to add
                 * @returns The object containing the value and carry value
                 */
                DynNumber.prototype._addDigits = function (left, right, carry) {
                    var result = new AddResult();
                    // These strings need to contain numbers small enough to be properly parsed by parseInt.
                    var num = parseInt(left, 10) + parseInt(right, 10) + parseInt(carry, 10);
                    if (isNaN(num)) {
                        throw new Error("NotANumber");
                    }
                    var factor = Math.pow(10, left.length);
                    result.value = this._padZeros((num % factor) + "", left.length, true);
                    result.carry = Math.floor(num / factor) + "";
                    return result;
                };
                /**
                 * Adds two strings containing positive integers
                 * @param leftNumberStr First integer to add
                 * @param rightNumberStr Second integer to add
                 * @returns The result after adding the integers
                 */
                DynNumber.prototype._addPositiveIntegers = function (leftNumberStr, rightNumberStr) {
                    var result = "";
                    var oneIdx = leftNumberStr.length;
                    var twoIdx = rightNumberStr.length;
                    // The maximum groups size is 9 because that is guaranteed to
                    // fit inside of the JavaScript number data type.
                    var groupSize = Math.min(9, oneIdx, twoIdx);
                    var oneDigit;
                    var twoDigit;
                    var curResult = null;
                    var notDone = ((oneIdx > 0) && (twoIdx > 0));
                    while (notDone === true) {
                        // Drop down to single digits at the end
                        if ((oneIdx - groupSize) < 0) {
                            groupSize = oneIdx;
                        }
                        else if ((twoIdx - groupSize) < 0) {
                            groupSize = twoIdx;
                        }
                        oneIdx -= groupSize;
                        twoIdx -= groupSize;
                        // Get right-most digits and add them
                        oneDigit = leftNumberStr.substr(oneIdx, groupSize);
                        twoDigit = rightNumberStr.substr(twoIdx, groupSize);
                        curResult = this._addDigits(oneDigit, twoDigit, curResult ? curResult.carry : "0");
                        // Add the value to the output
                        result = curResult.value + result;
                        notDone = ((oneIdx > 0) && (twoIdx > 0));
                        if (notDone === false) {
                            // Finish up by adding any existing carry and concatenating
                            // the remainder of the longer number
                            if (oneIdx > 0) {
                                // Adding the carry could cause (i.e. 9 + 1) another carry so keep passing it along if present
                                while ((parseInt(curResult.carry, 10) > 0) && (oneIdx > 0)) {
                                    oneDigit = leftNumberStr.substr(--oneIdx, 1);
                                    curResult = this._addDigits(oneDigit, curResult.carry, "0");
                                    result = curResult.value + result;
                                }
                                // If there is a part of the number that didn't need the carry, we can just concatenate it
                                if (oneIdx > 0) {
                                    result = leftNumberStr.substr(0, oneIdx) + result;
                                }
                            }
                            else if (twoIdx > 0) {
                                // Same logic as above if the second number was the larger number
                                while ((parseInt(curResult.carry, 10) > 0) && (twoIdx > 0)) {
                                    twoDigit = rightNumberStr.substr(--twoIdx, 1);
                                    curResult = this._addDigits(twoDigit, curResult.carry, "0");
                                    result = curResult.value + result;
                                }
                                if (twoIdx > 0) {
                                    result = rightNumberStr.substr(0, twoIdx) + result;
                                }
                            }
                            if (parseInt(curResult.carry, 10) > 0) {
                                // If both strings have been added check for a carry value
                                // No more of each number is left so just append the result to the carry (i.e. "1" + "000")
                                result = curResult.carry + result;
                            }
                        }
                    }
                    return result;
                };
                /**
                 * Compares two numbers
                 * @param left The left number in the comparison
                 * @param right The right number in the comparison
                 * @returns if left > right: 1, if left < right: -1, if left == right: 0, if either is NaN: -1
                 */
                DynNumber.prototype._compareDigits = function (left, right) {
                    var leftInt = parseInt(left, 10);
                    var rightInt = parseInt(right, 10);
                    // default -1 since so that if any of operands is NaN -1 is returned.
                    var compare = -1;
                    if (leftInt < rightInt) {
                        compare = -1;
                    }
                    else if (leftInt > rightInt) {
                        compare = 1;
                    }
                    else if (leftInt === rightInt) {
                        compare = 0;
                    }
                    return compare;
                };
                /**
                 * Compares two number structs
                 * @param leftNumberStruct The left number in the comparison
                 * @param rightNumberStruct The right number in the comparison
                 * @param ignoreDecimal Whether or not to ignore the decimal portion while comparing
                 * @returns if left > right: 1, if left < right: -1, if left == right: 0, if either is NaN: -1
                 */
                DynNumber.prototype._compareNumbers = function (leftNumberStruct, rightNumberStruct, ignoreDecimal) {
                    var compare = 0;
                    if ((leftNumberStruct.negative === true) && (rightNumberStruct.negative === false)) {
                        compare = -1;
                    }
                    else if ((leftNumberStruct.negative === false) && (rightNumberStruct.negative === true)) {
                        compare = 1;
                    }
                    else {
                        var leftInt = leftNumberStruct.integer;
                        var rightInt = rightNumberStruct.integer;
                        if (leftNumberStruct.isNaN || rightNumberStruct.isNaN) {
                            return -1;
                        }
                        if (leftInt.length === rightInt.length) {
                            var index = 0;
                            // The maximum groups size is 9 because that is guaranteed to
                            // fit inside of the JavaScript number data type.
                            var groupSize = Math.min(9, leftInt.length);
                            var leftDigit = void 0;
                            var rightDigit = void 0;
                            var notDone = (index < leftInt.length);
                            while (notDone === true) {
                                // Get left-most digits and compare them
                                leftDigit = leftInt.substr(index, groupSize);
                                rightDigit = rightInt.substr(index, groupSize);
                                compare = this._compareDigits(leftDigit, rightDigit);
                                // Adjust the index for the digits we just read
                                index += groupSize;
                                // Reduce the group size at the end
                                if ((index + groupSize) >= leftInt.length) {
                                    groupSize = leftInt.length - index;
                                }
                                notDone = ((index < leftInt.length) && (compare === 0));
                            }
                            // If the numbers are still equal, and have decimals we need to compare them
                            if ((ignoreDecimal === false) && (compare === 0)) {
                                var leftDecimal = leftNumberStruct.decimal;
                                var rightDecimal = rightNumberStruct.decimal;
                                if (leftDecimal.length > rightDecimal.length) {
                                    rightDecimal = this._padZeros(rightDecimal, leftDecimal.length, false);
                                }
                                else if (rightDecimal.length > leftDecimal.length) {
                                    leftDecimal = this._padZeros(leftDecimal, rightDecimal.length, false);
                                }
                                if (leftDecimal !== rightDecimal) {
                                    var leftTemp = new InternalNumber(leftDecimal);
                                    var rightTemp = new InternalNumber(rightDecimal);
                                    compare = this._compareNumbers(leftTemp, rightTemp, true);
                                }
                            }
                        }
                        else {
                            compare = (leftInt.length < rightInt.length) ? -1 : 1;
                        }
                        // We must invert the compare if the numbers are negative
                        if (leftNumberStruct.negative === true) {
                            compare = compare * -1;
                        }
                    }
                    return compare;
                };
                /**
                 * Parses numberStr and returns a number struct
                 * @param numberStr The number string to be parsed
                 * @param format The format to be used for the parsing
                 * @returns The number struct describing the parsed number string
                 */
                DynNumber.prototype._parseNumber = function (numberStr, format) {
                    var notANumber = /[\D]+/;
                    // Find the sign and value
                    var signValue = this._parseSignAndValue(numberStr, format);
                    var digits = signValue.value;
                    var decimalIsZero = false;
                    // Store the values
                    var result = new InternalNumber();
                    result.negative = signValue.negative;
                    result.isBlank = (numberStr === "");
                    // Find the decimal location
                    var decimalSep = format["."];
                    var decimalPosition = digits.indexOf(decimalSep);
                    if (decimalPosition < 0) {
                        result.integer = digits;
                        decimalIsZero = true;
                        result.decimal = "0";
                    }
                    else {
                        result.integer = digits.substr(0, decimalPosition);
                        // Precision is fixed on format
                        result.decimal = digits.substr(decimalPosition + decimalSep.length);
                        // Is the number actually zero?
                        if (this.nonZeroDigit.test(result.decimal) === false) {
                            decimalIsZero = true;
                            result.decimal = "0";
                        }
                    }
                    // Make sure that value contains only digits
                    if ((notANumber.test(result.integer)) || (notANumber.test(result.decimal))) {
                        result.isNaN = true;
                    }
                    else {
                        result.isNaN = false;
                    }
                    if (result.isNaN === false) {
                        // Trim leading zeros from the integer portion
                        result.integer = this._trimLeadingZeros(result.integer);
                        // Fix the sign if the number is Zero
                        if ((this.nonZeroDigit.test(result.integer) === false) && ((decimalIsZero === true) || (this.nonZeroDigit.test(result.decimal) === false))) {
                            result.negative = false;
                            result.isZero = true;
                        }
                    }
                    return result;
                };
                /**
                 * Formats the supplied number struct as an integer for display
                 * @param numberStruct The number struct to be displayed
                 * @param format The format to be used for display
                 * @returns The integer string
                 */
                DynNumber.prototype._formatInteger = function (numberStruct, format) {
                    return this._fixGroups(numberStruct.integer, format);
                };
                /**
                 * Formats the supplied number struct as a real for display
                 * @param numberStruct The number struct to be displayed
                 * @param format The format to be used for display
                 * @returns The real string
                 */
                DynNumber.prototype._formatReal = function (numberStruct, format) {
                    var formattedNumber = numberStruct.integer;
                    var decimalString = numberStruct.decimal;
                    var fixedDecimal = this._fixDecimal(decimalString, format);
                    decimalString = fixedDecimal.decimalString;
                    if (fixedDecimal.roundUp) {
                        formattedNumber = this._addPositiveIntegers(formattedNumber, "1");
                    }
                    formattedNumber = this._fixGroups(formattedNumber, format) + decimalString;
                    return formattedNumber;
                };
                /**
                 * Converts the decimal string according to the format
                 * @param decimalStr The decimal string to be converted
                 * @param format The format to be used for display
                 * @returns Object containing the decimal string rounded or padded to the number of decimals specified in the format
                 * and whether or not to round up the integer portion of the number
                 */
                DynNumber.prototype._fixDecimal = function (decimalStr, format) {
                    var precision = format.decimals;
                    var roundUp = false;
                    var paddedZeroCount = precision;
                    if (format.minDecimals >= 0 && format.minDecimals < precision) {
                        paddedZeroCount = format.minDecimals;
                    }
                    // Fix the number of decimals
                    // If there are too many decimal places we need to round
                    if (precision < decimalStr.length) {
                        var decimalNum = parseFloat("0." + decimalStr);
                        var factor = Math.pow(10, precision);
                        var roundedNum = Math.round(decimalNum * factor) / factor;
                        // If the rounded value is >=1 we need to add 1 to the integer
                        if (roundedNum >= 1) {
                            roundUp = true;
                        }
                        // Short circuit for precion of 0
                        if (precision > 0) {
                            // Remove the integer portion from the rounded number
                            var roundedNumDecimalStr = (roundedNum - Math.floor(roundedNum)).toFixed(precision);
                            // Find the index of the decimal separator so we can strip off
                            // the integer portion.
                            // This doesn't use the separator defined by the culture.
                            var decSepIdx = roundedNumDecimalStr.indexOf(".");
                            decimalStr = roundedNumDecimalStr.substr(decSepIdx + 1).replace(/0+$/, "");
                            // It is possible to round to "0".  If this happens we need to pad the decimals.
                            decimalStr = this._padZeros(decimalStr, paddedZeroCount, false);
                            // Trim to precision
                            decimalStr = decimalStr.substr(0, precision);
                            // Add the separator
                            if (decimalStr.length > 0) {
                                decimalStr = format["."] + decimalStr;
                            }
                        }
                        else {
                            decimalStr = "";
                        }
                    }
                    else {
                        if (decimalStr.length > 0) {
                            decimalStr = decimalStr.replace(/0+$/, "");
                        }
                        // Pad the decimals according to the precision
                        if (paddedZeroCount > 0 || decimalStr.length > 0) {
                            decimalStr = format["."] + this._padZeros(decimalStr, paddedZeroCount, false);
                        }
                    }
                    return { decimalString: decimalStr, roundUp: roundUp };
                };
                /**
                 * Splits the specified number string into groups separated by the group separator character
                 * @param numberStr The number string to be split
                 * @param format The format to be used for display
                 * @returns The number string with its' groups fixed
                 */
                DynNumber.prototype._fixGroups = function (numberStr, format) {
                    var groupSizes = format.groupSizes;
                    var currentGroupSize = groupSizes[0];
                    var currentGroupIndex = 1;
                    var separator = format[","];
                    // Break into groups
                    var stringIndex = numberStr.length - 1;
                    var ret = "";
                    // If numberStr is blank then it doesn't need any additional formatting
                    if (stringIndex < 0) {
                        return ret;
                    }
                    while (stringIndex >= 0) {
                        if ((currentGroupSize === 0) || (currentGroupSize > stringIndex)) {
                            return numberStr.slice(0, stringIndex + 1) + (ret.length ? (separator + ret) : "");
                        }
                        ret = numberStr.slice(stringIndex - currentGroupSize + 1, stringIndex + 1) + (ret.length ? (separator + ret) : "");
                        stringIndex -= currentGroupSize;
                        if (currentGroupIndex < groupSizes.length) {
                            currentGroupSize = groupSizes[currentGroupIndex++];
                        }
                    }
                    return numberStr.slice(0, stringIndex + 1) + separator + ret;
                };
                /**
                 * Formats the specified number struct
                 * @param numberStruct The number struct to be formatted
                 * @param format The format to be used
                 * @returns The formatted number string
                 */
                DynNumber.prototype.formatNumber = function (numberStruct, format) {
                    var formattedNumber = "";
                    var isNegative = (numberStruct.signMultiplier * (numberStruct.negative ? -1 : 1)) < 0;
                    if (numberStruct.isNaN === false) {
                        if (this._ignoreDecimal) {
                            formattedNumber = this._formatInteger(numberStruct, format);
                        }
                        else {
                            formattedNumber = this._formatReal(numberStruct, format);
                        }
                        // Add the negative pattern
                        if (isNegative && !numberStruct.isZero) {
                            var negativeSign = format["-"];
                            switch (format.pattern[0]) {
                                case "n -":
                                    formattedNumber += " ";
                                case "n-":
                                    formattedNumber += negativeSign;
                                    break;
                                case "- n":
                                    negativeSign += " ";
                                case "-n":
                                    formattedNumber = negativeSign + formattedNumber;
                                    break;
                                case "(n)":
                                    formattedNumber = "(" + formattedNumber + ")";
                                    break;
                            }
                        }
                        if (!isNegative && !numberStruct.isZero && numberStruct.showPositive) {
                            var positiveSign = format["+"] || "+";
                            switch (format.pattern[0]) {
                                case "n -":
                                    formattedNumber += " ";
                                case "n-":
                                    formattedNumber += positiveSign;
                                    break;
                                case "- n":
                                    positiveSign += " ";
                                case "-n":
                                    formattedNumber = positiveSign + formattedNumber;
                                    break;
                            }
                        }
                    }
                    else {
                        formattedNumber = Number.NaN.toString();
                    }
                    return formattedNumber;
                };
                return DynNumber;
            }());
            Numbers.DynNumber = DynNumber;
            // tslint:disable:no-string-literal
            DynNumber.prototype["nonZeroDigit"] = /[^0]/;
        })(Numbers = util.Numbers || (util.Numbers = {}));
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=NumberHelpers.js.map
